import React from "react";
import { Link } from "react-router-dom";

//Building blocks shared by the pages

//Photo at the top of the page, under the see-through header
//isBelowHeader: start the photo under the header instead of behind it (for photos with faces near the top)
export const PageHero = ({ src, alt = "", position, isBelowHeader = false }) => (
  <div className={`page-hero ${isBelowHeader ? "is-below-header" : ""}`}>
    <img
      src={src}
      alt={alt}
      style={position ? { objectPosition: position } : undefined}
    />
  </div>
);

//Gold band with the page title (the page's h1)
export const TitleBand = ({ title, isDisplayFont = false, children }) => (
  <section className={"title-band"}>
    <h1 className={`title-band-title ${isDisplayFont ? "is-display" : ""}`}>{title}</h1>
    {children}
  </section>
);

//Full-width parallax photo between sections
export const PhotoStrip = ({ src, label }) => (
  <div
    className={"photo-strip"}
    style={{ backgroundImage: `url(${src})` }}
    role={label ? "img" : undefined}
    aria-label={label}
  />
);

//Button that is either an internal page link, or an external link / file opened in a new tab
export const LinkButton = ({ path, href, className = "btn", children }) => (
  path ? (
    <Link
      to={path}
      className={className}
    >
      {children}
    </Link>
  ) : (
    <a
      href={href}
      className={className}
      target={"_blank"}
      rel={"noopener noreferrer"}
    >
      {children}
    </a>
  )
);

//One heading + text block in a split section
export const SplitItem = ({ title, text = [], listTitle, list, buttons, isDisplayFont = false, headingLevel = 2 }) => {
  const Heading = `h${headingLevel}`;
  return (
    <div className={"split-item"}>
      <Heading className={`heading ${isDisplayFont ? "is-display" : ""}`}>{title}</Heading>
      {text.map((paragraph) => (
        <p
          key={paragraph}
          className={"body-text"}
        >
          {paragraph}
        </p>
      ))}
      {list ? (
        <React.Fragment>
          <p className={"body-text split-list-title"}>{listTitle}</p>
          <ul className={"split-list"}>
            {list.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </React.Fragment>
      ) : null}
      {buttons ? (
        <div className={"split-buttons"}>
          {buttons.map((button) => (
            <LinkButton
              key={button.label}
              path={button.path}
              href={button.href}
            >
              {button.label}
            </LinkButton>
          ))}
        </div>
      ) : null}
    </div>
  );
};

//Half photo, half dark text panel. Photo goes first on phones
export const Split = ({ image, isImageFirst = false, media, id, children }) => (
  <section
    id={id}
    className={`split ${isImageFirst ? "is-image-first" : ""}`}
  >
    <div className={"split-content"}>{children}</div>
    <div className={"split-media"}>
      {media || (
        <img
          src={image.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
          loading={"lazy"}
        />
      )}
    </div>
  </section>
);
